import { create } from 'zustand';

interface AppState {
  status: string;
  progress: number | null;
  speed: string | null;
  setStatus: (status: string) => void;
  setProgress: (progress: number | null) => void;
  setSpeed: (speed: string | null) => void;
}

export const useAppStore = create<AppState>((set) => ({
  status: '就绪',
  progress: null,
  speed: null,
  setStatus: (status) => set({ status }),
  setProgress: (progress) => set({ progress }),
  setSpeed: (speed) => set({ speed }),
}));
